import { useCallback } from 'react'
import { fetchUserPosts } from '../api'
import { colors } from '../colors'
import { BackButton, InfinitePostList, PageContainer, PageHeader } from '../components'
import type { BargainUserInfo, Post } from '../types'

const styles: Record<string, React.CSSProperties> = {
  titleSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    padding: '16px 0',
    backgroundColor: colors['keijiban-coral-bg'],
    marginBottom: '8px',
  },
  title: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: colors['keijiban-brown'],
    marginBottom: '0',
  },
  postList: {
    paddingBottom: '100px',
  },
  footerButtons: {
    boxSizing: 'border-box',
    maxWidth: '640px',
    width: '100%',
    position: 'fixed',
    bottom: '16px',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: '8px 14px',
    gap: '8px',
  },
}

interface MypageProps {
  bargain_user_info: BargainUserInfo
  posts: Post[]
  total_count: number
}

const Mypage: React.FC<MypageProps> = ({ bargain_user_info, posts: initialPosts }) => {
  const fetchMorePosts = useCallback(async (page: number, offset: number) => {
    const response = await fetchUserPosts({ page, offset })
    return {
      posts: response.posts,
    }
  }, [])

  return (
    <PageContainer maxWidth="640px">
      <PageHeader title="おいしいもの掲示板" />

      <div style={styles.titleSection}>
        <h2 style={styles.title}>自分の口コミ</h2>
      </div>

      <div style={styles.postList}>
        <InfinitePostList
          initialPosts={initialPosts}
          bargain_user_info={bargain_user_info}
          fetchMorePosts={fetchMorePosts}
        />
      </div>

      <div style={styles.footerButtons}>
        <BackButton href="/message_board">
          <span className="icon_font icf_arrow_left" style={{ fontSize: '18px' }} />
          すべての口コミ
        </BackButton>

        <BackButton href="/webview/message_board/posts/new" variant="primary">
          <span className="icon_font icf_camera" style={{ fontSize: '18px' }} />
          投稿する
        </BackButton>
      </div>
    </PageContainer>
  )
}

export default Mypage
